export const SHOP_PRODUCT_ROUTER_ROOT = '/shop/product';
export const SHOP_STRIPE_ROOT_PATH = '/shop/stripe';



// WEBPACK FOOTER //
// ./src/components/Shop/constants.js